module.exports = __webpack_public_path__ + "media/images/frontend/tessin_ferienwohnungen_logo-4cb8ee4409091f83174ffd61b041a96c.svg";